import { styled } from '@atom-web/core'
import { Box, Row } from '@atom-web/micros'

function RibbonComponent({ backgroundcolor, children, top, left, mobile }) {
	const Ribbon = styled(Row, {
		height: '24px',
		width: 'fit-content',
		backgroundColor: backgroundcolor ? backgroundcolor : '$yellow05',
		borderTopLeftRadius: '$1',
		position: 'absolute',
		paddingRight: '$4',
		paddingLeft: '$3',
		minWidth: '$8',
		zIndex: 2,
		left: mobile ? mobile : '0px',
		top: top ? top : '$2',
		boxShadow: 'rgb(0 0 0 / 12%) 0px 2px 4px',
		'@lg': {
			borderTopLeftRadius: '$2',
			left: left ? left : '0px',
		},
	})
	return (
		<Ribbon justify={'center'} align="center" gap={'1'}>
			<Box
				css={{
					display: 'none',
					'@lg': {
						display: 'flex',
						position: 'absolute',
						width: '14px',
						height: '60%',
						backgroundColor: backgroundcolor ? backgroundcolor : '$yellow05',
						transform: 'skewY(45deg)',
						left: 0,
						bottom: '-9px',
					},
				}}
			></Box>
			<Box
				css={{
					position: 'absolute',
					width: '14px',
					height: '50%',
					transform: 'skewX(315deg)',
					right: '-6px',
					top: 0,
					backgroundColor: backgroundcolor ? backgroundcolor : '$yellow05',
				}}
			></Box>
			<Box
				css={{
					position: 'absolute',
					width: '14px',
					height: '50%',
					transform: 'skewX(45deg)',
					right: '-6px',
					bottom: 0,
					backgroundColor: backgroundcolor ? backgroundcolor : '$yellow05',
				}}
			></Box>
			{children}
		</Ribbon>
	)
}
export default RibbonComponent
